import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useReportRun} from '../hooks/useReportRun';
import {ReportRun} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useReportRun();

    const todayMidnightUtc = Math.floor(new Date(new Date().toISOString().split('T')[0]).getTime() / 1000);
    const oneMonthAgo = todayMidnightUtc - 30 * 24 * 60 * 60;

    return (
        <FormDrawer
            record={{
                id: '',
                reportType: '',
                currency: 'usd',
                timezone: 'America/Los_Angeles',
                intervalStart: oneMonthAgo,
                intervalEnd: todayMidnightUtc,
            } as ReportRun}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
